"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
const BookPublished = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M20.5 6.5h-1.773V5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h2.527v1.5H3.5v13h17v-13zm-1.148-3v13.926a.5.5 0 0 1-.434.496c-2.625.353-4.82 1.278-6.596 2.773a.5.5 0 0 1-.822-.383V5.966a.5.5 0 0 1 .15-.358C13.436 3.867 15.846 3 18.853 3a.5.5 0 0 1 .5.5zm-1 13.495V4.009c-2.437.086-4.38.811-5.852 2.17v13.116c1.66-1.175 3.613-1.942 5.852-2.3zM4.67 3.5a.5.5 0 0 1 .5-.5c3.007 0 5.417.867 7.2 2.607a.5.5 0 0 1 .152.358v14.348a.5.5 0 0 1-.822.382c-1.776-1.495-3.971-2.42-6.597-2.773a.5.5 0 0 1-.433-.496V3.5zm1 13.495c2.239.358 4.191 1.125 5.852 2.3V6.18C10.05 4.82 8.107 4.095 5.67 4.009v12.986z", children: " " })
] });
var BookPublished_default = BookPublished;
export {
  BookPublished_default as default
};
